import React, { Component } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import LeadManagementHome from '../components/LeadManagementNew/LeadManagementHome';

const FETCH_LEAD_TASK_STATUS_DETAILS = gql`
  query($employee_id: Int!, $institute_id: Int!) {
    getLeadTaskStatusDetails(employee_id: $employee_id, institute_id: $institute_id ) {
        lead_status_details
    }
  }
`;


const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
          educationalClasses {
            id
            class
          }
        classes{
            id
            class
        }
        exams{
            id
            exam
            exam_subjects{
                subject_id
              }
        }
          globalBranches{
            id
            branch_name
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
          }
          globalPackages {
            id
            package_name
            exams_covered
          }
          globalCategories {
            id
            category_name
            package_id
          }
          offlineExamSubjects{
            id
            subject
          }
    }
}

`;

const GET_CALL_STATUS_TYPES = gql`
  query($id: Int!) {
    getCallStatusTypes(id: $id) {
        id
        calling_status
    }
  }
`;

const GET_LEAD_STATUS_TYPES = gql`
  query($institute_id: Int!) {
    getLeadStatusTypes(institute_id: $institute_id) {
        id
        lead_status_type
    }
  }
`;


const FETCH_NEXT_LEVEL_USER_AND_EMPLOYEE = gql`
  query($institute_id: Int!,$branch_id: Int!,$head_employee_id: Int!,$is_grouping: Boolean!) {
    getNextLevelUserAndEmployeeDetails(institute_id: $institute_id,branch_id: $branch_id,head_employee_id: $head_employee_id,is_grouping: $is_grouping) {
      level_id
      employee_id
      employee_name
      next_level_emp
      status_details
    }
}
`;

const FETCH_NEXT_LEVEL_TOTAL_USERS = gql`
  query($institute_id: Int!,$branch_id: Int!,$employee_id: Int!) {
    getNextLevelTotalUsers(institute_id: $institute_id,branch_id: $branch_id,employee_id: $employee_id) {
        status_details
        total_users_details{
          employee_id
          employee_name
          lead_details
        }
    }
}
`;

class LeadManagementNew extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {


        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }


        const getCallStatusTypes = this.props.getCallStatusTypes;
        const loading2 = getCallStatusTypes.loading;
        const error2 = getCallStatusTypes.error;

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        const getLeadStatusTypes = this.props.getLeadStatusTypes;
        const loading3 = getLeadStatusTypes.loading;
        const error3 = getLeadStatusTypes.error

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }
        const getNextLevelUserAndEmployeeDetails = this.props.getNextLevelUserAndEmployeeDetails;
        const loading4 = getNextLevelUserAndEmployeeDetails.loading;
        const error4 = getNextLevelUserAndEmployeeDetails.error
        console.log("getNewEducationalStudents", getNextLevelUserAndEmployeeDetails);

        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }

        const getLeadTaskStatusDetails = this.props.getLeadTaskStatusDetails;
        const loading5 = getLeadTaskStatusDetails.loading;
        const error5 = getLeadTaskStatusDetails.error

        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        const getNextLevelTotalUsers = this.props.getNextLevelTotalUsers;
        const loading6 = getNextLevelTotalUsers.loading;
        const error6 = getNextLevelTotalUsers.error

        if (error6 !== undefined) {
            alert("Server Error. " + error6.message);
            return null;
        }


        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
                        <Container fluid>
                            {

                                loading1 || loading2 || loading3 || loading4 || loading5 || loading6 ?
                                    (
                                        <Container><Row className="my-3">
                                            <Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row></Container>
                                    ) : (

                                        <LeadManagementHome
                                            globals={globals.globals}
                                            getCallStatusTypes={getCallStatusTypes.getCallStatusTypes}
                                            getLeadStatusTypes={getLeadStatusTypes.getLeadStatusTypes}
                                            getLeadTaskStatusDetails={getLeadTaskStatusDetails.getLeadTaskStatusDetails}
                                            getNextLevelUserAndEmployeeDetails={getNextLevelUserAndEmployeeDetails.getNextLevelUserAndEmployeeDetails}
                                            getNextLevelTotalUsers={getNextLevelTotalUsers.getNextLevelTotalUsers}
                                        />
                                    )

                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>)
    }
}

export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))

                    }
                }), name: "globals"
            }),
        graphql(GET_CALL_STATUS_TYPES, {
            options: (props) => ({
                variables: {
                    id: 0,
                },
            }),
            name: "getCallStatusTypes",
        }), graphql(GET_LEAD_STATUS_TYPES, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid"))
                },
            }),
            name: "getLeadStatusTypes",
        }),
        graphql(FETCH_LEAD_TASK_STATUS_DETAILS, {
            options: (props) => ({
                variables: {
                    employee_id: parseInt(Cookies.get("id")),
                    institute_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "getLeadTaskStatusDetails",
        }),
        graphql(FETCH_NEXT_LEVEL_USER_AND_EMPLOYEE, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(Cookies.get("branch_id")),
                    head_employee_id: parseInt(Cookies.get("id")),
                    is_grouping: false,
                },
            }),
            name: "getNextLevelUserAndEmployeeDetails",
        }),
        graphql(FETCH_NEXT_LEVEL_TOTAL_USERS, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(Cookies.get("branch_id")),
                    employee_id: parseInt(Cookies.get("id")),
                },
            }),
            name: "getNextLevelTotalUsers",
        }),

    )(LeadManagementNew));
